import type { ChatAction } from "../models/game/action";
import type { ApiGame } from "../types/apigame";

export enum GameFog {
    None = 0,
    Light,
    Heavy,
};

export enum GamePlaceUnitsState {
    Normal = 0,
    JustUnits = 1,
    BlindAtOnceUnits = 2,
};

export enum GameRulesUnitPlacement {
    Static = 0,
    Risk = 1,
    BlindAtOnceUnits = 2,
    Random = 3,
};

export enum GameRulesTeamSelection {
    Automatic = 0,
    Manual = 1,
};

export enum GameRulesTeamTransfers {
    None = 0,
    ToTeammate = 1,
    MoveTeammate = 2,
};

export enum GameRulesTeamDefense {
    Fight = 0,
    InstantlyLose = 1,
    JoinTeammate = 2,
};

export enum GameRulesWinCondition {
    Default = 0,
    Assassin = 1,
    Catan = 2,
    Capitals = 3,
    Percent = 4,
};

export enum GamePlayerType {
    User = 0,
    Bot = 1,
};

export enum GameChatChannel {
    Global = 0,
    Team,
};

export enum GameSpecialSeats {
    Neutral = -1,
    Fogged = -2,
    Invisible = -3,
    Blizzard = -4,
};

export const GameSpecialSeatNames = {
    [GameSpecialSeats.Invisible]: 'The Void',
    [GameSpecialSeats.Fogged]: 'Fog',
    [GameSpecialSeats.Neutral]: 'Neutral',
    [GameSpecialSeats.Blizzard]: 'Blizzard',
}

export const GAME_SPECIAL_SEAT_NAME_UNKNOWN = 'Unknown';

export function getSpecialSeatName(seatNumber: number): string {
    return GameSpecialSeatNames[seatNumber]
        ?? GAME_SPECIAL_SEAT_NAME_UNKNOWN;
}

export type ChatError = {
    status: 'error';
    message: string;
};

export type ChatSuccess = {
    status: 'success';
    game: ApiGame;
    action: ChatAction;
};

export type ChatResponse = ChatError | ChatSuccess;

export enum GamePrivacy {
    InviteOnly = 0,
    AnyoneCanJoin,
};

export enum GameUnseenActionsState {
    None = 0,
    ChatsOnly = 1,
    ReplayAvailable = 2,
};

export enum GameDangerousAttackType {
    None = 0,
    Teammate,
    TeammateInstantlyLose,
    TeammateInstantlyLoseWithStack,
    TeammateJoinTeammate,
}

export enum JoinGameErrorSource {
    Join = 'join',
    Start = 'start',
}

export enum GameFortifyMode {
    NeighborsOnly = 0,
    ConnectedPath,
}

export enum GameCardTurninMode {
    Progressive = 0,
    Fixed,
    Exponential,
}

export const SPECIAL_SEAT_IMAGE_MAP: Record<number, string> = {
    [GameSpecialSeats.Fogged]: 'fog.png',
    [GameSpecialSeats.Invisible]: 'invisible.png',
};

export enum GameViewMode {
    Play = 0,
    Map,
    Simulator,
    ChatTag,
};
